var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCar = function SvgCar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6667 10.3335C15.932 10.3335 16.1863 10.2281 16.3739 10.0406C16.5614 9.85307 16.6667 9.59871 16.6667 9.3335V7.83283C16.6665 7.51303 16.5395 7.20637 16.3134 6.98016L14.6667 5.3335H3.66675L2.02008 6.98016C1.79402 7.20637 1.66695 7.51303 1.66675 7.83283V9.3335C1.66675 9.59871 1.7721 9.85307 1.95964 10.0406C2.14718 10.2281 2.40153 10.3335 2.66675 10.3335H15.6667Z",
    stroke: "#000033",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.77466 7.3335H4.25266C4.51769 7.33355 4.77186 7.43882 4.95932 7.62616L5.66666 8.3335",
    stroke: "#000033",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5587 7.3335H14.0807C13.8157 7.33355 13.5615 7.43882 13.3741 7.62616L12.6667 8.3335",
    stroke: "#000033",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.66675 5.3335L4.80008 2.30683C4.9073 2.02063 5.09943 1.77403 5.35072 1.60007C5.602 1.42611 5.90045 1.3331 6.20608 1.3335H12.1274C12.4327 1.33351 12.7307 1.42671 12.9816 1.60064C13.2325 1.77457 13.4243 2.02095 13.5314 2.30683L14.6647 5.3335H3.66675Z",
    stroke: "#000033",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.66675 5.3335L2.66675 4.3335H1.66675",
    stroke: "#000033",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6667 5.3335L15.6667 4.3335H16.6667",
    stroke: "#000033",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M2.66675 10.3335V11.3335C2.66675 11.5987 2.7721 11.8531 2.95964 12.0406C3.14718 12.2281 3.40153 12.3335 3.66675 12.3335C3.93196 12.3335 4.18632 12.2281 4.37386 12.0406C4.56139 11.8531 4.66675 11.5987 4.66675 11.3335V10.3335H2.66675Z",
    stroke: "#000033",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6667 10.3335V11.3335C15.6667 11.5987 15.5614 11.8531 15.3739 12.0406C15.1863 12.2281 14.932 12.3335 14.6667 12.3335C14.4015 12.3335 14.1472 12.2281 13.9596 12.0406C13.7721 11.8531 13.6667 11.5987 13.6667 11.3335V10.3335H15.6667Z",
    stroke: "#000033",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgCar;